import { Component } from 'react';
import PropTypes from 'prop-types';
import hashString from 'string-hash';
import { withRouter } from 'core/libs/router';

import { createPath } from 'core/utils/url-helper';

import RequestIdContext from '.';

// Генерируем детерминированный `requestId` на основе `location`.
function generateRequestId(location) {
  return `${hashString(createPath(location))}`;
}

class RequestIdProvider extends Component {
  static propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string,
      search: PropTypes.string,
      state: PropTypes.object,
    }),
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    /**
     * state.infinity используется для бесконечного скролла в статье,
     * при изменении урла в этом случае requestId обновлять не нужно.
     */
    if (nextProps.location.state && nextProps.location.state.infinity) {
      return null;
    }

    const nextRequestId = generateRequestId(nextProps.location);

    if (prevState.requestId === nextRequestId) {
      return null;
    }

    if (process.env.BROWSER_RUNTIME) {
      // Anti-Adblock. При клиентской навигации перевызываем рекламу.
      window.QW50aS1BZEJsb2Nr && window.QW50aS1BZEJsb2Nr.reconnect();
      // ssp spa refresh event
      window.Adf && window.Adf.banner && window.Adf.banner.spaPageUpdate();
    }

    return {
      requestId: nextRequestId,
    };
  }

  state = {
    requestId: generateRequestId(this.props.location),
  };

  render() {
    return (
      <RequestIdContext.Provider value={this.state.requestId}>
        {this.props.children}
      </RequestIdContext.Provider>
    );
  }
}

const RequestIdProviderWithHOCs = withRouter(RequestIdProvider);
RequestIdProviderWithHOCs.displayName = 'RequestIdProvider';

export { RequestIdProvider as StorybookComponent };
export default RequestIdProviderWithHOCs;
